import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Register global axios session interceptor before anything else
import "./data/Axios/AxiosConfig";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";

const client = new ApolloClient({
  uri: "https://localhost:44353/graphql/",
  cache: new InMemoryCache(),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
      ,
    </BrowserRouter>
  </React.StrictMode>
);
